import React, { useState } from "react";
import { Drawer, List, ListItemButton, ListItemText, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky"
            color={"error"}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={handleMenu}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          EchoBud - An OpenAI powered Whatsapp Assistant
        </Typography>
        <Drawer anchor={"top"}
                open={open}
                onClose={handleClose}>
          <List>
            <ListItemButton onClick={() => (navigate("/"))}>
              <ListItemText primary={"Home"} />
            </ListItemButton>
            <ListItemButton onClick={() => (navigate("/contact"))}>
              <ListItemText>Contact</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => (navigate("/privacy-policy"))}>
              <ListItemText>Privacy Policy</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => (navigate("/terms"))}>
              <ListItemText>Terms</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => (navigate("/data-deletion"))}>
              <ListItemText>Data Deletion</ListItemText>
            </ListItemButton>
          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
